import React from "react";
import Globe from "./Globe";

function App() {
  return <Globe />;
}

export default App;